(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  // Swiper JS is included via CDN in the theme's footer

  document.addEventListener('DOMContentLoaded', function() {
    function initializeSwiper() {
      const carousels = document.querySelectorAll('.announcement-carousel .swiper');

      carousels.forEach(function(carousel) {
        // Prevent initializing Swiper multiple times
        if (carousel.swiperInstance) return;

        const swiper = new Swiper(carousel, {
          loop: true,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: carousel.querySelector('.swiper-button-next'),
            prevEl: carousel.querySelector('.swiper-button-prev'),
          },
          pagination: {
            el: carousel.querySelector('.swiper-pagination'),
            clickable: true,
          },
          // Responsive breakpoints
          breakpoints: {
            0: {
              slidesPerView: 1,
              spaceBetween: 0,
            },
            641: {
              slidesPerView: 1,
              spaceBetween: 0,
            }
          }
        });

        // Store the Swiper instance to prevent re-initialization
        carousel.swiperInstance = swiper;
      });
    }

    function checkWindowSize() {
      if (window.innerWidth <= 640) { // Tailwind's sm breakpoint
        initializeSwiper();
      } else {
        // Destroy Swiper instances if window is resized above 640px
        const carousels = document.querySelectorAll('.announcement-carousel.swiper');
        carousels.forEach(function(carousel) {
          if (carousel.swiperInstance) {
            carousel.swiperInstance.destroy(true, true);
            carousel.swiperInstance = null;
          }
        });
      }
    }

    // Initial check
    checkWindowSize();

    // Debounced resize event to prevent excessive function calls
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        checkWindowSize();
      }, 250); // Adjust timeout as needed
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  
class LocalizationForm extends HTMLElement {
constructor() {
super();
this.elements = {
input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
button: this.querySelector('button'),
};
this.elements.button.addEventListener('click', this.openSelector.bind(this));
this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
}

onContainerKeyUp(event) {
if (event.code.toUpperCase() !== 'ESCAPE') return;

this.elements.button.focus();
}

onItemClick(event) {
event.preventDefault();
const form = this.querySelector('form');
this.elements.input.value = event.currentTarget.dataset.value;
if (form) form.submit();
}

openSelector() {
this.elements.button.focus();
this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
}

closeSelector(event) {
const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
}
}

customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();
})();
